import { IChartSeries } from '@mais-retorno-front/models/chart-serie';
import { IAssetQuotes } from '../interfaces';

export const createComparisonNetWorthSerie = (
  assetQuotes: IAssetQuotes[]
): IChartSeries[] => {
  if (!assetQuotes) return;

  const serie = assetQuotes.map((quotes) => {
    return {
      data: quotes.quotes.map(({ d, p = 0 }) => [d, p]),
      name: quotes.nicename,
      color: quotes.color,
      id: quotes.id,
      type: 'area',
      fillOpacity: 0.2,
    };
  });

  return serie;
};
